import React from 'react';

import { useDialog } from '@/hooks/useDialog';

type Props = {
  children?: React.ReactNode;
  className?: string;
  'aria-label'?: string;
  as?: React.ElementType;
  toggleChildren: React.ReactNode;
};

export const Dropdown: React.FC<Props> = ({
  as: Toggle = 'button',
  className,
  'aria-label': ariaLabel,
  toggleChildren,
  children,
}) => {
  const { ref, handleToggleVisibility, show } = useDialog();

  return (
    <div className="ml-3 relative" ref={ref}>
      <div>
        <Toggle className={className} aria-label={ariaLabel} aria-haspopup="true" onClick={handleToggleVisibility}>
          {toggleChildren}
        </Toggle>
      </div>

      {/*!--
        Profile dropdown panel, show/hide based on dropdown state.

        Entering: "transition ease-out duration-200"
          From: "transform opacity-0 scale-95"
          To: "transform opacity-100 scale-100"
        Leaving: "transition ease-in duration-75"
          From: "transform opacity-100 scale-100"
          To: "transform opacity-0 scale-95"
      -->*/}
      {show && children}
    </div>
  );
};
